import AuthService from '@/_services/auth.service'
import { createRouter, createWebHashHistory } from 'vue-router'
import axios from 'axios'

import DefaultLayout from '@/layouts/DefaultLayout'

import routeSuperAdmin from '@/router/SuperAdministrator/route.js'
import routeAdmin from '@/router/Administrator/route.js'
import routeFacility from '@/router/Facility/route.js'
import routeAppUser from '@/router/AppUser/route.js'

import 'vue3-toastify/dist/index.css'
import store from '@/store'
import { toast } from 'vue3-toastify'

let payload
let user = JSON.parse(localStorage.getItem('user'))
//console.log(user)
if (user) {
  payload = AuthService.getPayload()
}

if (window.location.hash == '#/app/login') {
  localStorage.setItem('APP_CONTEXT', 'APP')
} else if (window.location.hash == '#/backend/login') {
  localStorage.setItem('APP_CONTEXT', 'UMWA')
}

let customRoute = ''

if (payload) {
  if (payload.roleId == '1') {
    customRoute = routeSuperAdmin
  } else if (payload.roleId == '2') {
    customRoute = routeAdmin
  } else if (payload.roleId == '3') {
    customRoute = routeFacility
  } else if (payload.roleId == '4') {
    customRoute = routeAppUser
  }
}

let routes = [
  {
    path: '/:processIdent',
    component: () => import('@/views/frontend/Survey.vue'),
    children: [
      {
        path: '/survey/:processIdent',
        name: 'Survey',
      },
    ],
  },
  {
    path: '/backend',
    component: DefaultLayout,
    meta: { layout: 'umwa' },
    redirect: '/backend/dashboard',
    children: customRoute,
  },
  {
    path: '/backend/password',
    name: 'Passwort vergessen',
    component: () => import('@/views/ForgotPassword.vue'),
  },
  {
    path: '/backend/setPassword/:setPasswordToken',
    name: 'Passwort',
    component: () => import('@/views/SetPassword.vue'),
  },
  {
    path: '/backend/login',
    name: 'Login',
    component: () => import('@/views/Login'),
  },
  {
    path: '/backend/logout',
    name: 'Logout',
    component: () => import('@/views/Logout'),
  },
  {
    path: '/app/register',
    name: 'App-Register',
    component: () => import('@/views/anamnese/Register'),
  },
  {
    path: '/app/login',
    name: 'App-Login',
    meta: { title: 'Kur + Reha App - Login' },
    component: () => import('@/views/anamnese/Login'),
  },
  {
    path: '/app/logout',
    name: 'App-Logout',
    component: () => import('@/views/anamnese/Logout'),
  },
  {
    path: '/app/password',
    name: 'Passwort vergessen',
    component: () => import('@/views/anamnese/ForgotPassword.vue'),
  },
  {
    path: '/app',
    component: DefaultLayout,
    meta: { layout: 'app' },
    redirect: '/app/survey',
    children: customRoute,
  },
  {
    path: '/page503',
    component: () => import('@/views/Page503.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/Page404.vue'),
  },
]

let router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

router.beforeEach(async (to, from, next) => {
  if (window.location.hash == '#/app/login') {
    localStorage.setItem('APP_CONTEXT', 'APP')
  } else if (window.location.hash == '#/backend/login') {
    localStorage.setItem('APP_CONTEXT', 'UMWA')
  }

  const title =
    typeof to.meta.title === 'function' ? to.meta.title(to) : to.meta.title
  // Den Titel im Browser setzen (Fallback auf Standardwert)
  document.title = title || 'UMWA Tool'

  const publicPages = [
    '/backend/login',
    '/backend/logout',
    '/app/register',
    '/app/login',
    '/app/logout',
    '/page404',
    '/page503',
  ]
  let authRequired = !publicPages.includes(to.path)

  if (to.matched[0].path == '/:processIdent') {
    authRequired = false
    document.title = 'Umfrage'
  }

  let API_URL = 'https://' + window.location.host + ''

  if (window.location.host === '192.168.21.44:8443') {
    API_URL = 'https://dev.umfrage2023.kur.org'
  }

  let user = JSON.parse(localStorage.getItem('user'))

  if (user) {
    axios.defaults.headers['Authorization'] = 'Bearer ' + user.accessToken
  }
  //let canUserAccess = function (to) {
  //return true
  //}
  if (authRequired && user) {
    //const canAccess = await canUserAccess(to)
    //console.log(canAccess)
    const params = {
      refresh: true,
      user: {
        type: 'fe',
      },
    }
    axios.post(API_URL + '/api/auth/checkLogin', params).then((response) => {
      if (response) {
        if (response.data.status == 'error') {
          user = null
          if (localStorage.getItem('APP_CONTEXT') == 'UMWA') {
            router.push('/backend/logout')
          }
          if (localStorage.getItem('APP_CONTEXT') == 'APP') {
            router.push('/app/logout')
          }
        }
      } else {
        user = null
        if (localStorage.getItem('APP_CONTEXT') == 'UMWA') {
          router.push('/backend/logout')
        }
        if (localStorage.getItem('APP_CONTEXT') == 'APP') {
          router.push('/app/logout')
        }
      }
    })
  }
  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !user) {
    if (localStorage.getItem('APP_CONTEXT') == 'UMWA') {
      next('/backend/login')
    }
    if (localStorage.getItem('APP_CONTEXT') == 'APP') {
      next('/app/login')
    }
  } else {
    next()
  }
})

router.afterEach(() => {
  if (store.state.message !== '') {
    toast(store.state.message, {
      autoClose: 5000,
      type: store.state.messageTyp,
      theme: 'colored',
      position: 'top-center',
      closeOnClick: false,
      //multiple: false,
    })
    store.state.message = ''
  }
})

export default router
